import { RandomIcon } from "./RandomIcon";
export default RandomIcon;
